module.exports = __webpack_public_path__ + "img/bgzh.1a561431.png";